// @flow

import * as React from "react";
import Page from "../../components/Page/Page";
import Article from "../../components/Article/Article";
import Block from "../../components/Block/Block";
import task from "./task";

import "./instructions.css";

const PapersInstructions = () => {
  const question = task.renderQuestion({
    id: "",
    question: "",
    answer: false,
    responseTimesInSeconds: [],
    metadata: {
      title: "Adaptive Step-Size for Policy Gradient Methods",
      abstract:
        "In the last decade, policy gradient methods have significantly grown in popularity in the reinforcement-learning field. In particular, they have been largely employed in motor control and robotic applications, thanks to their ability to cope with continuous state and action domains and partial observable problems. Policy gradient researches have been mainly focused on the identification of effective gradient directions and the proposal of efficient estimation algorithms. Nonetheless, ...",
      reviews: [
        {
          text:
            "summary: The paper provides potentially useful theoretical analyses and good alternative of policy gradient methods. It would be much more convincing if there are more experimental comparisons with state-of-art methods such as EM policy search. assessment: This paper provides a theoretically grounded adaptive step size for policy gradient methods in which the lower bound of the expected policy improvement is maximized. Approximated version of step size can be computed only by estimated gradient and thus the computational complexity would be same as ordinary policy gradient methods. There is a mild assumption that the standard deviation of Gaussian policy is fixed for deriving the lower bound. Experimental results show..."
        },
        {
          text:
            "summary: Overall, I like the approach of thoroughly studying the interplay between step size and policy performance. While the paper could be improved with clearer, more direct results, I think this is a fine, albeit incremental result for NIPS. assessment: This paper investigates how to automatically set the step size of policy gradient methods, in particular focusing on the Gaussian policy case. The paper provides a lower bound on the difference in performance when taking a gradient step, and optimizes this lower bound with respect to the step size. Overall, I like the approach of thoroughly studying the interplay between step size and policy performance. While the paper could be improved with clearer, more direct results, I think this is a fine, albeit incremental result for NIPS. Quality. The paper contains a hefty amount of theoretical work, but..."
        }
      ]
    },
    project: { id: "", name: "", template: "" }
  });
  return (
    <Page>
      <Article>
        <h1>ML Paper Preferences</h1>
        <p>
          In each round, you will see a recent machine learning paper along with
          conference reviews. Here’s an example (in the real thing you also see the full PDF):
        </p>
        <Block className="Papers-Instructions-Example">{question}</Block>

      <h2>Instructions</h2>
      <ol>
      <li>
      Your task is to estimate whether this is the kind of paper you’d like to read -- based on your personal preference, not an objective judgment of quality.
      </li>
      <li>
      You first make a quick guess (after 30 seconds) about how much you’d like the paper, and then you give another evaluation after 3 mins and 20 mins.
      </li>
      <li>
      These guesses should indicate the probability that you’ll like the paper. If you have no idea, chose “50%” on the scale. If there’s a good chance you’d like the paper (e.g. it’s related to your own work), you might say “85%”. If you've already read the paper, you can immediately submit your considered judgment three times.
      </li>
      <li>
      After we finish collecting data, we’ll use your judgments to recommend papers to you. Please use the time available to refine your judgments about the papers -- don’t rely on your initial impression.
      </li>
      </ol>
      <p>Do you understand the instructions? If not, ping us using the messenger in the bottom right corner.</p>
      
      </Article>
    </Page>
  );
};

export default PapersInstructions;



// WEBPACK FOOTER //
// ./src/templates/papers/instructions.js